import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { useEffect } from 'react'


const propTypes = {
  isOpen             : PropTypes.bool.isRequired,
  toggle             : PropTypes.func.isRequired,
  handleConfirmation : PropTypes.func,
  onCancel           : PropTypes.func,
  reverseActions     : PropTypes.bool,
  title              : PropTypes.string,
  children           : PropTypes.any
}

/**
 * Modal for confirming the certain process to double check the action.
 * @param {bool} isOpen - State for open / close the modal
 * @param {func} toggle - Toggle to open / close the modal
 * @param {string} title - Title of the modal
 * @param {any} children - Can be message or component
 * @param {func} handleConfirmation - Handler to execute the process
 */
const ConfirmationModal = ({
  isOpen,
  toggle,
  title,
  children,
  handleConfirmation,
  onCancel = () => {},
  reverseActions = false
}) => {
  const [ isSubmitting, setIsSubmitting ] = useState(false)

  const handleOnClick = () => {
    // * execute handleConfirmation
    // * set the button to disable
    handleConfirmation()
    setIsSubmitting(true)
  }

  const handleCancelClick = () => {
    onCancel()
    toggle()
  }

  useEffect(() => {

    // * automatically set isSubmitting to false when the modal has reopened
    if (isOpen) {
      setIsSubmitting(false)
    }
  }, [ isOpen ])

  return (
    <Modal isOpen={ isOpen } toggle={ toggle }>
      <ModalHeader toggle={ toggle }>
        { title }
      </ModalHeader>
      <ModalBody>
        <div className='py-3 text-center'>
          <div className='mb-4'>
            <i className="fas fa-exclamation fa-5x"></i>
          </div>
          { children }
        </div>
      </ModalBody>
      <ModalFooter>
        <div className='d-flex justify-content-between'>
          <div
            className={ `flex-fill ${reverseActions ? '' : 'mr-3'}` }
            style={{ order: reverseActions ? 2 : 1 }}
          >
            <Button
              block
              color="secondary"
              disabled={ isSubmitting }
              onClick={ handleCancelClick }
            >
            Cancel
            </Button>
          </div>
          <div
            className={ `flex-fill ${reverseActions ? 'mr-3' : ''}` }
            style={{ order: reverseActions ? 1 : 2 }}
          >
            <Button
              block
              color='primary'
              disabled={ isSubmitting }
              onClick={ handleOnClick }
            >
              {
                isSubmitting
                  ? <i className="ni ni-settings-gear-65 spin"/>
                  : 'Okay'
              }
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

ConfirmationModal.propTypes = propTypes

export default ConfirmationModal
